import { render, staticRenderFns } from "./ResultUpload.vue?vue&type=template&id=2186c71d"
import script from "./ResultUpload.vue?vue&type=script&lang=js"
export * from "./ResultUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports